<template>
  <v-main>
    <v-container fluid>
      <v-row align="center" justify="center">
      <v-data-table
        :headers="headers"
        fixed-header
        height="50vh"
        :items="wallets"
        :loading="loading"
        :search="search"
        :sort-desc="[false, true]"
        multi-sort
        dark
        dense
        class="table"
        item-key="email"
        scope="props"
      >
        <template v-slot:top>
          <v-toolbar flat dark rounded>
            <v-toolbar-title>Wallets</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field class="search" v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            <export-excel :data="wallets" name="wallets">
              <v-btn color="primary"><v-icon color="white">mdi-file-download</v-icon></v-btn>
            </export-excel>
          </v-toolbar>
        </template>
        <template v-slot:[`item.transactions`]="{ item }">
          <span @click="openTransactionsDialog(item.transactions)"><a>Open</a></span>
           <v-dialog v-model="transactionsDialog._enabled" width="350" :retain-focus="false">
            <v-container class="grey darken-4 px-10s">
              <v-row class="flex-column mb-3" v-for="(transaction, i) in item.transactions" :key="i">
                <div class="d-flex">Amount: <span class="ml-auto gold">{{ transaction.amount | brl }}</span></div>
                <div class="d-flex">Description: <span class="ml-auto gold">{{ transaction.description }}</span></div>
                <div class="d-flex">Type: <span class="ml-auto gold">{{ transaction.type }}</span></div>
                <div class="d-flex">Status: <span class="ml-auto gold">{{ transaction.status }}</span></div>
                <div class="d-flex">Created At: <span class="ml-auto gold">{{ transaction.createdAt | date }}</span></div>
              </v-row>
            </v-container>
          </v-dialog>
        </template>
        <template v-slot:[`item.withDraws`]="{ item }">
          <span @click="openWithDrawsDialog(item.withDraws)"><a>Open</a></span>
           <v-dialog v-model="withDrawsDialog._enabled" width="350" :retain-focus="false">
            <v-container class="grey darken-4 px-10">
              <v-row class="flex-column mb-3" v-for="(withdraw, i) in item.withDraws" :key="i">
                <div class="d-flex">Status: <span class="ml-auto gold">{{ withdraw.status }}</span></div>
                <div class="d-flex mt-3"><h4 class="mr-auto gold">Unlock</h4></div>
                <div class="d-flex">Code: <span class="ml-auto gold">{{ withdraw.unlock.code }}</span></div>
                <div class="d-flex">Created At: <span class="ml-auto gold">{{ withdraw.unlock.createdAt | date }}</span></div>
                <div class="d-flex">Valid Until: <span class="ml-auto gold">{{ withdraw.unlock.validUntil | date }}</span></div>
                <div class="d-flex">Created At: <span class="ml-auto gold">{{ withdraw.createdAt | date }}</span></div>
                <v-divider class="mt-3"></v-divider>
              </v-row>
            </v-container>
          </v-dialog>
        </template>
        <template v-slot:[`item.createdAt`]="{ item }">
          <span>{{ formatDate(item) }}</span>
        </template>
      </v-data-table>
      </v-row>
    </v-container>
  </v-main>
</template>

<style lang="scss">
  .table {
    width: 85%;
    z-index: 1;
    .search {
      margin-right: 25px;
      max-width: 300px;
    }
  }
  th {
    span { font-size: 15px; }
    color: gold !important;
  }
  .v-dialog { box-shadow: none !important; }
  .large { min-width: 125px; }
  .gold { color: gold; }
  .black { background: #1d1d1d; }
  .pointer { cursor: pointer; }
</style>

<script>
/* eslint-disable */
import { upperCaseFirstLetter } from '@/utils/strings'
import { formatDate } from '@/utils/date'

const translatedTableTitles = {}
const translatedTableFields = {}
const translatedGeneralWordsAndPhrases = {}

const hiddenTableColumns = ['id', 'link', 'references', 'notifications']

export default {
  name: 'Wallets',
  data () {
    return {
      loading: true,
      search: '',
      headers: [],
      wallets: [],
      transactionsDialog: {
        _enabled: false,
        items: []
      },
      withDrawsDialog: {
        _enabled: false,
        items: []
      },
    }
  },
  mounted () {
    let headerCreated = false
    let wallet = {}

    this.$axios.get('wallet/search', {
      data: { isEmpty: false }
    }).then(res => {
      res.data.forEach(wallets => {
        if (!headerCreated) {
          for (const key of Object.entries(wallets)) {
            if (key[0] === 'link') {
              this.headers.push(
                { text: 'User Name', value: 'link.userName' },
                { text: 'User Email', value: 'link.userEmail' }
              )
            }  
            this.headers.push({ text: upperCaseFirstLetter(key[0]), value: key[0], class: 'large', align: hiddenTableColumns.includes(key[0]) ? ' d-none' : '' })
          }
          
          headerCreated = true;
        }
        wallet = {}
        for (const key of Object.entries(wallets)) {  
          wallet = {...wallet, [key[0]]: key[1] }
        }
        this.wallets.push(wallet)
      });
      this.loading = false
    })
    .catch(err => console.log(err))
  },
  computed: {
    //formTitle () { return this.configDialog.itemIndex === -1 ? 'Include Config' : 'Edit Config' }
  },
  methods: {
    openTransactionsDialog (transactions) {
      this.transactionsDialog = { _enabled: true, transactions }
    },
    openWithDrawsDialog (withdraws) {
      this.withDrawsDialog = { _enabled: true, ...withdraws }
    },
    translateTableTitle (word) { return (word in translatedTableTitles) ? translatedTableTitles[word] : word },
    translateTableField (word) { return (word in translatedTableFields) ? translatedTableFields[word] : word },
    translateGeneralWordsAndPhrases (expression) { return (expression in translatedGeneralWordsAndPhrases) ? translatedGeneralWordsAndPhrases[expression] : expression },
    formatDate(date) { return formatDate(date) }    
  },
}
</script>